import "core-js/modules/es.object.freeze.js";
import { clientReloadInterceptor } from "@faire/web/common/requests/response-interceptors/clientReloadInterceptor";
import { errorLoggingInterceptor } from "@faire/web/common/requests/response-interceptors/errorLoggingInterceptor";
export var responseInterceptors = Object.freeze([errorLoggingInterceptor, clientReloadInterceptor]);